import React, { lazy } from "react";

const LazyDownloadTranslation = lazy(() => import("./DownloadTranslation"));

const DownloadTranslation = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => <LazyDownloadTranslation {...props} />;

export default DownloadTranslation;
